<template>
  <div class="alerts-overlay">
    <alert-box-item
      v-for="message in messages"
      :key="message.id"
      :message="message"
    />
  </div>
</template>

<script lang="ts">
import { Message } from "@/store/messages";
import { Options, Vue } from "vue-class-component";
import { mapState } from "vuex";
import AlertBoxItem from "./AlertBoxItem.vue";

@Options({
  components: {
    AlertBoxItem,
  },
  computed: {
    ...mapState("messages", ["messages"]),
  },
})
export default class AlertBox extends Vue {
  messages!: Message[];
}
</script>

<style lang="scss">
.alerts-overlay {
  position: fixed;
  top: 0;
  left: 0;
  margin: 32px 8px 8px;
  z-index: 200;
  box-sizing: border-box;
  width: calc(100vw - 16px);
}
</style>
